"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubjectCRFPollingStatus = exports.StudyDwSasCb = exports.StudyDwSas = exports.StudyDwHistory = exports.SasFileCbStatus = exports.SasFileGenerateAsyncStatus = exports.StudyDataWarehouseStatus = exports.StudyDataWarehouseUrlType = exports.StudyDataWarehouseSubType = exports.StudyDataWarehouseType = void 0;
var StudyDataWarehouseType;
(function (StudyDataWarehouseType) {
    StudyDataWarehouseType["Dataset"] = "DATASET";
    StudyDataWarehouseType["BlankCRF"] = "BLANK_CRF";
    StudyDataWarehouseType["DbSpecification"] = "DB_SPECIFICATION";
    StudyDataWarehouseType["SubjectCRFs"] = "SUBJECT_CRFS";
    StudyDataWarehouseType["Report"] = "REPORT";
    StudyDataWarehouseType["SaeReport"] = "SAE_REPORT";
    StudyDataWarehouseType["UatReport"] = "UAT_REPORT";
    StudyDataWarehouseType["ReportList"] = "REPORT_LIST";
    StudyDataWarehouseType["QueryList"] = "QUERY_LIST";
    StudyDataWarehouseType["AuditTrail"] = "AUDIT_TRAIL";
    StudyDataWarehouseType["Comments"] = "COMMENTS";
    StudyDataWarehouseType["CrfStatusList"] = "CRF_STATUS_LIST";
    StudyDataWarehouseType["CrfStatusByVisitList"] = "CRF_STATUS_BY_VISIT_LIST";
    StudyDataWarehouseType["CrfStatusBySubjectList"] = "CRF_STATUS_BY_SUBJECT_LIST";
    StudyDataWarehouseType["CrfStatusBySiteList"] = "CRF_STATUS_BY_SITE_LIST";
    StudyDataWarehouseType["CustomDataCrf"] = "CUSTOM_DATA_CRF";
    StudyDataWarehouseType["ReportDataset"] = "REPORT_DATASET";
    StudyDataWarehouseType["TemplateReport"] = "TEMPLATE_REPORT";
    StudyDataWarehouseType["ScheduledReport"] = "SCHEDULED_REPORT";
})(StudyDataWarehouseType = exports.StudyDataWarehouseType || (exports.StudyDataWarehouseType = {}));
var StudyDataWarehouseSubType;
(function (StudyDataWarehouseSubType) {
    StudyDataWarehouseSubType["Report_Ae"] = "REPORT:AE";
    StudyDataWarehouseSubType["Report_Sae"] = "REPORT:SAE";
    StudyDataWarehouseSubType["Report_Pregnancy"] = "REPORT:PREGNANCY";
    StudyDataWarehouseSubType["Report_Aesi"] = "REPORT:AESI";
    StudyDataWarehouseSubType["Report_Qc"] = "REPORT:QC";
    StudyDataWarehouseSubType["ReportDataset_Ae"] = "REPORT_DATASET:AE";
    StudyDataWarehouseSubType["ReportDataset_Sae"] = "REPORT_DATASET:SAE";
    StudyDataWarehouseSubType["ReportDataset_Pregnancy"] = "REPORT_DATASET:PREGNANCY";
    StudyDataWarehouseSubType["ReportDataset_Aesi"] = "REPORT_DATASET:AESI";
    StudyDataWarehouseSubType["ReportDataset_Qc"] = "REPORT_DATASET:QC";
})(StudyDataWarehouseSubType = exports.StudyDataWarehouseSubType || (exports.StudyDataWarehouseSubType = {}));
var StudyDataWarehouseUrlType;
(function (StudyDataWarehouseUrlType) {
    StudyDataWarehouseUrlType["Dataset"] = "dataset";
    StudyDataWarehouseUrlType["BlankCRF"] = "blank-crf";
    StudyDataWarehouseUrlType["DbSpecification"] = "db-spec";
    StudyDataWarehouseUrlType["SubjectCRFs"] = "subject-crfs";
    StudyDataWarehouseUrlType["Report"] = "reports";
    StudyDataWarehouseUrlType["SaeReport"] = "sae-reports";
    StudyDataWarehouseUrlType["UatReport"] = "uat-report";
    StudyDataWarehouseUrlType["ReportList"] = "report-list";
    StudyDataWarehouseUrlType["QueryList"] = "query-list";
    StudyDataWarehouseUrlType["AuditTrail"] = "audit-trail";
    StudyDataWarehouseUrlType["Comments"] = "comments";
    StudyDataWarehouseUrlType["CustomDataCrf"] = "custom-data-crf";
    StudyDataWarehouseUrlType["ReportDataset"] = "report-dataset";
    StudyDataWarehouseUrlType["ScheduledReport"] = "scheduled-report";
})(StudyDataWarehouseUrlType = exports.StudyDataWarehouseUrlType || (exports.StudyDataWarehouseUrlType = {}));
var StudyDataWarehouseStatus;
(function (StudyDataWarehouseStatus) {
    StudyDataWarehouseStatus["Requested"] = "REQUESTED";
    StudyDataWarehouseStatus["Generating"] = "GENERATING";
    // NOTE: SAS File은 Completed Status로 maven-sas쪽에서 파일 생성 완료 및 callback을 보냄.
    StudyDataWarehouseStatus["Completed"] = "COMPLETED";
    StudyDataWarehouseStatus["Done"] = "DONE";
    StudyDataWarehouseStatus["Failed"] = "FAILED";
})(StudyDataWarehouseStatus = exports.StudyDataWarehouseStatus || (exports.StudyDataWarehouseStatus = {}));
var SasFileGenerateAsyncStatus;
(function (SasFileGenerateAsyncStatus) {
    SasFileGenerateAsyncStatus["Requested"] = "REQUESTED";
    SasFileGenerateAsyncStatus["Ready"] = "READY";
    SasFileGenerateAsyncStatus["Defined"] = "DEFINED";
    SasFileGenerateAsyncStatus["Submitted"] = "SUBMITTED";
    SasFileGenerateAsyncStatus["Executing"] = "EXECUTING";
    SasFileGenerateAsyncStatus["Running"] = "RUNNING";
    SasFileGenerateAsyncStatus["Completed"] = "COMPLETED";
    SasFileGenerateAsyncStatus["Done"] = "DONE";
    SasFileGenerateAsyncStatus["Failed"] = "FAILED";
})(SasFileGenerateAsyncStatus = exports.SasFileGenerateAsyncStatus || (exports.SasFileGenerateAsyncStatus = {}));
var SasFileCbStatus;
(function (SasFileCbStatus) {
    SasFileCbStatus["Wait"] = "WAIT";
    SasFileCbStatus["Ready"] = "READY";
    SasFileCbStatus["Processing"] = "PROCESSING";
    SasFileCbStatus["Done"] = "DONE";
    SasFileCbStatus["Failed"] = "FAILED";
})(SasFileCbStatus = exports.SasFileCbStatus || (exports.SasFileCbStatus = {}));
class StudyDwHistory {
}
exports.StudyDwHistory = StudyDwHistory;
class StudyDwSas {
}
exports.StudyDwSas = StudyDwSas;
class StudyDwSasCb {
}
exports.StudyDwSasCb = StudyDwSasCb;
var SubjectCRFPollingStatus;
(function (SubjectCRFPollingStatus) {
    SubjectCRFPollingStatus["Wait"] = "WAIT";
    SubjectCRFPollingStatus["Processing"] = "PROCESSING";
    SubjectCRFPollingStatus["Failed"] = "FAILED";
    SubjectCRFPollingStatus["Done"] = "DONE";
})(SubjectCRFPollingStatus = exports.SubjectCRFPollingStatus || (exports.SubjectCRFPollingStatus = {}));
//# sourceMappingURL=studyDataWarehouse.js.map